import HttpRequest from './core/http_request';

class ExpertProvider extends HttpRequest {
  getListExpert () {
    return this.request('get', '/expert');
  }
}

export default ExpertProvider;
